module.exports = __webpack_public_path__ + "img/piggy-bank.c6de9de8.svg";